import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[appScrollableItem]'
})
export class ScrollableItemDirective {

  @Input('appScrollableItem') public patient_reason_code_desc!: string
  constructor(private el: ElementRef<HTMLElement>) {}

  public scrollIntoView() {
    this.el.nativeElement.scrollIntoView({ behavior: 'smooth'});
  }

}